/* TWRD hover-boks paa links (Oliver 2026-10-06). Delt komponent, se snippets/twrd-link-tip.liquid.
   Laeser kortet over destinationer (JSON fra snippet), finder links inden for scope og viser
   EN delt boks (position: fixed) over linket ved hover eller tastaturfokus.
   Vender boksen under linket, hvis der ikke er plads over (sticky header taeller med).
   Holder boksen inden for skaermen vandret. Roerer ikke linkets egen markup eller tekst. Kun mus. */
(function () {
  'use strict';
  if (window.__twTip) return;
  window.__twTip = 1;
  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var GAP = 14, EDGE = 12, W = 240;
  var map = {}, scopes = [];
  var nodes = document.querySelectorAll('script[data-tw-tip-map]');
  for (var n = 0; n < nodes.length; n++) {
    try {
      var m = JSON.parse(nodes[n].textContent);
      for (var k in m) if (Object.prototype.hasOwnProperty.call(m, k)) map[k] = m[k];
    } catch (e) { if (window.console) console.warn('twrd-link-tip: bad map', e); }
    var sc = nodes[n].getAttribute('data-scope');
    if (sc) scopes.push(sc);
  }
  if (!scopes.length) return;

  function entryFor(a) {
    var raw = a.getAttribute('href');
    if (!raw || raw.charAt(0) === '#' || a.getAttribute('data-tw-tip') === 'off') return null;
    var u;
    try { u = new URL(raw, location.href); } catch (e) { return null; }
    if (u.protocol !== 'https:' && u.protocol !== 'http:') return null;
    if (u.host === location.host || /(^|\.)thwrd\.com$/.test(u.hostname)) {
      if (u.hash && u.pathname === location.pathname) return null;
      var p = u.pathname.replace(/\/+$/, '') || '/';
      return map[p] || map[p.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, '')] || null;
    }
    return map['host:' + u.hostname.replace(/^www\./, '')] || null;
  }

  var tip, img, key, line, cur = null, curY = null, raf = 0;
  function build() {
    tip = document.createElement('div');
    tip.className = 'tw-tip';
    tip.setAttribute('aria-hidden', 'true');
    tip.innerHTML = '<div class="tw-tip__in"><img class="tw-tip__img" alt="" width="240" height="135" decoding="async"><span class="tw-tip__k"></span><span class="tw-tip__t"></span></div>';
    img = tip.querySelector('img'); key = tip.querySelector('.tw-tip__k'); line = tip.querySelector('.tw-tip__t');
    document.body.appendChild(tip);
  }

  function setImg(el, e) {
    if (e.x) el.referrerPolicy = 'no-referrer'; else el.removeAttribute('referrerpolicy');
    if (e.i) { if (el.getAttribute('src') !== e.i) el.src = e.i; el.hidden = false; } else { el.removeAttribute('src'); el.hidden = true; }
  }

  /* Bunden af det, der ligger fast i toppen (sticky header, bjaelker). */
  function safeTop() {
    var b = 0, seen = [], els = document.elementsFromPoint ? document.elementsFromPoint(innerWidth / 2, 2) : [];
    for (var i = 0; i < els.length; i++) {
      for (var el = els[i]; el && el !== document.body && el !== document.documentElement; el = el.parentElement) {
        if (seen.indexOf(el) !== -1 || el === tip) break;
        seen.push(el);
        var pos = getComputedStyle(el).position;
        if (pos === 'fixed' || pos === 'sticky') { var r = el.getBoundingClientRect(); if (r.top <= 2 && r.bottom > b) b = r.bottom; }
      }
    }
    return Math.min(b, innerHeight / 2);
  }

  function place() {
    if (!cur) return;
    var rects = cur.getClientRects();
    if (!rects.length) { hide(); return; }
    var r = rects[0];
    if (curY != null) for (var i = 0; i < rects.length; i++) if (curY >= rects[i].top - 2 && curY <= rects[i].bottom + 2) { r = rects[i]; break; }
    var vw = document.documentElement.clientWidth, h = tip.offsetHeight;
    var cx = r.left + r.width / 2;
    var left = Math.max(EDGE, Math.min(cx - W / 2, vw - EDGE - W));
    var top = r.top - GAP - h, below = top < safeTop() + 8;
    if (below) top = r.bottom + GAP;
    tip.classList.toggle('is-below', below);
    tip.style.left = Math.round(left) + 'px';
    tip.style.top = Math.round(top) + 'px';
    tip.style.setProperty('--tw-tip-px', Math.round(Math.max(14, Math.min(W - 14, cx - left))) + 'px');
  }

  function show(a, y) {
    var e = a.__twTip;
    if (!tip) build();
    setImg(img, e);
    key.textContent = e.k || '';
    line.textContent = e.t || '';
    cur = a; curY = y;
    place();
    tip.classList.add('is-on');
  }
  function hide() { if (tip) tip.classList.remove('is-on'); cur = null; curY = null; }

  function onScroll() {
    if (!cur || raf) return;
    raf = requestAnimationFrame(function () { raf = 0; curY = null; place(); });
  }

  function preload(e) {
    if (!e.i || e.__pre) return;
    e.__pre = 1;
    var im = new Image();
    if (e.x) im.referrerPolicy = 'no-referrer';
    im.decoding = 'async';
    im.src = e.i;
  }

  function wire(a) {
    if (a.__twTip !== undefined) return;
    var e = entryFor(a);
    a.__twTip = e;
    if (!e) return;
    a.addEventListener('mouseenter', function (ev) { show(a, ev.clientY); });
    a.addEventListener('mouseleave', function () { if (cur === a) hide(); });
    a.addEventListener('focus', function () { var fv = false; try { fv = a.matches(':focus-visible'); } catch (x) {} if (fv) show(a, null); });
    a.addEventListener('blur', function () { if (cur === a) hide(); });
    if (io) io.observe(a); else preload(e);
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (en) { if (en.isIntersecting) { preload(en.target.__twTip); io.unobserve(en.target); } });
  }, { rootMargin: '400px 0px' }) : null;

  function init() {
    for (var s = 0; s < scopes.length; s++) {
      var roots;
      try { roots = document.querySelectorAll(scopes[s]); } catch (e) { if (window.console) console.warn('twrd-link-tip: bad scope', scopes[s]); continue; }
      for (var i = 0; i < roots.length; i++) {
        if (roots[i].tagName === 'A') wire(roots[i]);
        var as = roots[i].querySelectorAll('a[href]');
        for (var j = 0; j < as.length; j++) wire(as[j]);
      }
    }
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') hide(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
